import { useState, useEffect, useRef } from 'react';

const useIntersectionObserver = (options, deps = []) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  // Reset visibility when deps change (e.g. contract or company changed)
  useEffect(() => {
    setIsVisible(false);
  }, [...deps]);

  useEffect(() => {
    const element = elementRef.current;
    
    // If it's already visible, we don't need to observe anymore
    if (isVisible || !element) return;

    const observer = new IntersectionObserver(([entry]) => {
      // Is intersecting means it entered our rootMargin
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect(); // Only trigger once
      }
    }, options);

    observer.observe(element);

    return () => {
      if (element) {
        observer.unobserve(element);
      }
      observer.disconnect();
    };
  }, [isVisible, options, ...deps]);

  return { elementRef, isVisible };
};

export default useIntersectionObserver;
